@import '~style-sheet-helpers/core.less';
@import '../../../../../../../constants/spacing.module.less';

.header {
  display: flex;
  align-items: center;
  gap: @space-8;
}

.seat-counter {
  color: var(--gray-637381);
  font-size: 13px;
  font-weight: @normal;
}

.checkbox {
  margin-bottom: 5px;

  > label {
    font-size: 14px;
    font-weight: @bold;
  }
}

.radio-group {
  padding-left: 28px;
}

.radio-row {
  display: flex;
  align-items: center;
  gap: @space-16;

  .radio-button {
    padding-top: @space-4;
    padding-bottom: 0;
  }
}
